import './user-pages.sass';
import axios from 'axios';
import { useState } from 'react';
import useAlert from '../hooks/useAlert';
import useConfirm from '../hooks/useConfirm';
import { useTranslation } from 'react-i18next';

const Transfer = () => {
	const { t, i18n } = useTranslation();
	const token = localStorage.getItem('token');
	const { sendAlert } = useAlert();
	const { sendConfirm } = useConfirm();

	const [form, setForm] = useState({
		amountToTransfer: '',
		receiverEmail: '',
	});

	const { amountToTransfer, receiverEmail } = form;

	const inputChange = (event, field) => {
		setForm({ ...form, [field]: event.target.value });
	}

	const checkForm = (event) => {
		event.preventDefault();
		let hasError = false;

		if (!amountToTransfer || !receiverEmail) {
			sendAlert(t('transfer.msg_miss_all'));
			hasError = true;
		}

		if (Number.isNaN(amountToTransfer)) {
			sendAlert(t('transfer.msg_invalid_num'));
			hasError = true;
		}

		if (Number(amountToTransfer) < 1) {
			sendAlert(t('transfer.msg_invalid_num'));
			hasError = true;
		}

		if (!Number.isInteger(Number(amountToTransfer))) {
			sendAlert(t('transfer.msg_must_int'));
			hasError = true;
		}

		if (!hasError) {
			sendConfirm({
				title: `${t('transfer.msg_confirm')} ${amountToTransfer}`,
				message: receiverEmail,
				onConfirm: submitForm,
			});
		}
	}

	const submitForm = () => {
		axios.post('/token/transfer', form, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}).then((response) => {
			const message = response.data.message;

			if (message === 'success') {
				sendAlert(t('transfer.msg_success'));

				setForm({
					amountToTransfer: '',
					receiverEmail: '',
				});
			}
		}).catch((error) => {
			const message = error.response.data.message;

			switch (message) {
				case 'Amount to transfer must be given':
					sendAlert(t('transfer.msg_invalid_num'));
					break;

				case 'The balance of the sender is not enough':
					sendAlert(t('transfer.msg_balance'));
					break;

				case 'The receiver is not found':
					sendAlert(t('transfer.msg_not_found'));
					break;

				case 'The receiver cannot be the same as the sender':
					sendAlert(t('transfer.msg_same'));
					break;

				default:
					sendAlert('Oops!', message);
					break;
			}
		});
	}

	return (
		<div id='Transfer' className='user-pages'>
			<div className='page-title'>{t('navbar.menu_transfer_point')}</div>
			{/* <div className='page-content' style={{ 'marginBottom': '10px' }}>您可以透過電子郵件地址發送點數給對方</div> */}
			<div className='page-content'>
				<form className='form' onSubmit={checkForm}>
					<div className='input-wrap'>
						<div className='label'>{t('transfer.input_email_title')}</div>
						<input type='email' value={receiverEmail} placeholder={t('transfer.input_email_placeholder')} onChange={(e) => { inputChange(e, 'receiverEmail') }} />
					</div>

					<div className='input-wrap'>
						<div className='label'>{t('transfer.input_amount_title')}</div>
						<input type='number' min='1' value={amountToTransfer} placeholder={t('transfer.input_amount_placeholder')} onChange={(e) => { inputChange(e, 'amountToTransfer') }} />
					</div>

					<div className='button-wrap'>
						<button>{t('transfer.btn_submit')}</button>
					</div>
				</form>
			</div>

			<div className='monetization-block'>Google ad</div>
		</div>
	)
}

export default Transfer;